module.exports = __webpack_public_path__ + "assets/normal/images/user-m.0eb1cca1.png";